import { render, staticRenderFns } from "./theme.vue?vue&type=template&id=11a6db3f"
import script from "./theme.vue?vue&type=script&lang=js"
export * from "./theme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11a6db3f')) {
      api.createRecord('11a6db3f', component.options)
    } else {
      api.reload('11a6db3f', component.options)
    }
    module.hot.accept("./theme.vue?vue&type=template&id=11a6db3f", function () {
      api.rerender('11a6db3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/theme.vue"
export default component.exports